import { Link } from "@mui/material";
import { TbShirtSport } from "react-icons/tb";
import { HiOutlineTicket } from "react-icons/hi";
import { MdOutlineEventSeat, MdOutlinedFlag } from "react-icons/md";

export const purchaseSeatsLanguages = {
  similarSeatModalBody: (seatTitle: string) => (
    <>
      We are going to apply the same or similar seats to all games in your pack.
      Seat locations will be visible on the checkout page.
    </>
  ),
  progressBarText:
    "Add 2 games for 10% off, add 3 games for 20% off, add 4 games for 30% off, and add 6+ games for the opportunity to watch batting practice for one of the games you purchase!",
  progressBarAditionalText:
    " for 10% off, 2 more games for 20% off, 3 more games for 30% off or 5+ games for an exclusive batting practice opportunity.",
};

function SWBRailRidersLink({ text }: { text: string }) {
  return (
    <Link
      target={"_blank"}
      sx={{
        fontWeight: 500,
        color: "primary.main",
        textDecoration: "none",
      }}
      href={"https://am.ticketmaster.com/swbyankees/"}
    >
      {text}
    </Link>
  );
}

export const howItWorks = [
  {
    icon: <MdOutlinedFlag />,
    title: "Choose Your Games",
    description: "Select the games you wish to attend.",
  },
  {
    icon: <MdOutlineEventSeat />,
    title: "Login to Account Manager",
    description:
      "Click Continue and connect your SWB RailRiders account using our secure Ticketmaster login.",
  },
  {
    icon: <TbShirtSport />,
    title: "Select Your Seats",
    description: "Select the seats you wish to purchase for each game.",
  },
  {
    icon: <HiOutlineTicket />,
    title: "Get Your Tickets",
    description: (
      <>
        Tickets will be available in your{" "}
        <SWBRailRidersLink text="Account Manager" /> in early 2025. Reach out to
        Live Fan Support for any questions.
      </>
    ),
  },
];

export const faqs = [
  {
    title: "How does the SWB RailRiders Flex Program work?",
    description: (
      <>
        The SWB RailRiders Flex Program allows fans to select any seat to select
        games hosted by the RailRiders. The more games you select the higher
        your price discount! Simply log into your SWB RailRiders{" "}
        <SWBRailRidersLink text="Account Manager" /> and select games.
      </>
    ),
  },
  {
    title: "Do I have to select all my games now?",
    description: "Yes, you must select all games at the time of purchase.",
  },
  {
    title: "Can I choose seats throughout the venue?",
    description: "Yes, you can choose from all current available inventory.",
  },
  {
    title: "Where are event tickets delivered?",
    description: (
      <>
        Tickets are delivered directly within your SWB RailRiders{" "}
        <SWBRailRidersLink text="Account Manager." />
      </>
    ),
  },
  {
    title: "How do I receive my promotional items with my game selection?",
    description: (
      <>
        The SWB RailRiders Box Office team will work with you to ensure you are
        set up for your batting practice experience if you qualify! We will be
        in touch after your purchase and can be reached at{" "}
        <Link
          href="tel:5709692255"
          sx={{
            fontWeight: 500,
            color: "primary.main",
            textDecoration: "none",
          }}
        >
          (570) 969-2255
        </Link>
        .
      </>
    ),
  },
];
